import React from "react";
import { PeekAccordion, PeekAccordionSummary, PeekAccordionDetails, useTheme } from "@piiqtechnologies/ui-components";
const CustomAccordion = ({ expanded, onChange, summaryContent, detailsContent }) => {
    const theme = useTheme();
    return (React.createElement(PeekAccordion, { expanded: expanded, onChange: onChange, sx: {
            boxShadow: `0px 1px 8px 2px ${theme.palette.grey[50]}`,
            border: "1px solid",
            borderColor: theme.palette.grey[100],
        } },
        React.createElement(PeekAccordionSummary, { expandIcon: null, "aria-controls": "accordion-content", id: "accordion-header", sx: {
                padding: 0,
                minHeight: 40,
                "> .MuiAccordionSummary-content": {
                    margin: 0,
                    marginLeft: 1,
                },
            } }, summaryContent),
        detailsContent && (React.createElement(PeekAccordionDetails, { sx: {
                px: 0,
                pointerEvents: expanded ? "auto" : "none",
                opacity: expanded ? 1 : 0.7,
            } }, detailsContent))));
};
export default CustomAccordion;
